// crewbit-admin/src/lib/proposalCategoryLabels.ts
//
// Tier 2-UI Phase B (admin) — display-label map for the 26 ExpenseCategory
// enum values resolved by propose_expense_categorization (Migration 273
// extended by Migration 282 in §WorldClass.3 Phase A). Mirrors
// crewbit-mobile/lib/proposalCategoryLabels.ts body decisions per
// `feedback_admin_pair_must_match_mobile_body`. Mobile maps to i18n keys
// (react-i18next); admin is hardcoded English (admin convention per S139 —
// i18n migration is queued §Settings.AdminI18nMigration).
//
// Forward-compatible: when §WorldClass.3.AdminLogExpensePanelFullCanonical
// ships full canonical save on admin, the same map continues serving as the
// source of truth for proposal-display labels (consumed by ProposalReasoningTooltip
// and the future override picker).

import type { ExpenseCategory } from '../types/proposals';

export const PROPOSAL_CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  office_supplies: 'Office supplies',
  motor_vehicle_fuel: 'Motor vehicle — Fuel',
  motor_vehicle_insurance: 'Motor vehicle — Insurance',
  motor_vehicle_maintenance: 'Motor vehicle — Repairs & maintenance',
  telephone_internet: 'Telephone & internet',
  meals_entertainment: 'Meals & entertainment',
  professional_fees: 'Professional fees',
  subcontractor: 'Subcontractor',
  materials: 'Materials',
  tools_small: 'Tools (small)',
  insurance_business: 'Business insurance',
  rent_business: 'Business rent',
  utilities_business: 'Business utilities',
  advertising: 'Advertising',
  bad_debt_writeoff: 'Bad debt write-off',
  bank_fees: 'Bank fees',
  license_business: 'Business licenses',
  travel: 'Travel',
  home_office: 'Home office',
  cca_class: 'Capital purchase (CCA)',
  mileage: 'Mileage',
  software_subscriptions: 'Software & subscriptions',
  uniforms: 'Uniforms',
  training: 'Training',
  product_inventory: 'Product inventory',
  other: 'Other',
};

export const PROPOSAL_CATEGORY_VALUES: ExpenseCategory[] = [
  'office_supplies',
  'motor_vehicle_fuel',
  'motor_vehicle_insurance',
  'motor_vehicle_maintenance',
  'telephone_internet',
  'meals_entertainment',
  'professional_fees',
  'subcontractor',
  'materials',
  'tools_small',
  'insurance_business',
  'rent_business',
  'utilities_business',
  'advertising',
  'bad_debt_writeoff',
  'bank_fees',
  'license_business',
  'travel',
  'home_office',
  'cca_class',
  'mileage',
  'software_subscriptions',
  'uniforms',
  'training',
  'product_inventory',
  'other',
];
